// extracted by mini-css-extract-plugin
export default {"card":"GameCard_card__mW9AO","thumbnail":"GameCard_thumbnail__b3jzE","overlay":"GameCard_overlay__ZcCjl","overlayTitle":"GameCard_overlayTitle__Rsezm"};